'use client';

import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../utils/constants';
import auth from '../../Auth';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { Button } from '@nextui-org/react';
import Breadcrumbs from '../Breadcrumbs';

const Log = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [requestMessages, setRequestMessages] = useState('');
  const [responseMessages, setResponseMessages] = useState('');
  const [logTimestamp, setLogTimestamp] = useState(null)

  const query = new URLSearchParams(location.search);
  const promptIdParam = query.get('prompt_id');
  const timestampParam = query.get('timestamp');
  console.log('promptIdParam:', promptIdParam, 'timestampParam:', timestampParam);

  const fetchIdealAnswer = async () => {
    try {
      const response = await axios.get(`${API_URL}/logs/ideal_answer?prompt_id=${promptIdParam}&timestamp=${timestampParam}`, {
        headers: {
          Authorization: `Bearer ${await auth.getIdToken()}`
        }
      });
      if (response.status === 200) {
        const data = response.data;
        setResponseMessages(prev => prev += '## Ideal answer:\n' + data.ideal_answer);
      }
    } catch (error) {
      console.error('Error fetching ideal answer:', error);
    }
  }

  // 1. fetch prompt data with version
  useEffect(() => {
    console.log('fetching log');
    const fetchLog = async () => {
      try {
        const response = await axios.get(`${API_URL}/logs/log?prompt_id=${promptIdParam}&timestamp=${timestampParam}`, {
          headers: {
            Authorization: `Bearer ${await auth.getIdToken()}`
          }
        });
        if (response.status === 200) {
          const log = response.data;
          setLogTimestamp(log.timestamp)
          const log_response = log.response;
          let response_msg = '';
          if (log_response.role) {
            response_msg += log_response.role + ':\n';
          } else {
            response_msg += '## Assistant:\n';
          }
          if (log_response.content) {
            response_msg += log_response.content;
          }
          if (log_response.function_call) {
            response_msg += '## Function Call:\n' + JSON.stringify(log_response.function_call) + '\n';
          }
          if (log_response.tool_calls) {
            response_msg += '## Function Call:\n' + JSON.stringify(log_response.tool_calls) + '\n';
          }
          setResponseMessages(response_msg);
        }
      } catch (error) {
        console.error('Error fetching prompt:', error);
      }
    };
    fetchLog();
    fetchIdealAnswer()
  }, []);

  //3. fetch request
  useEffect(() => {
    console.log('fetching request');
    const fetchContext = async () => {
      const response = await axios.get(`${API_URL}/logs/request?prompt_id=${promptIdParam}&timestamp=${timestampParam}`, {
        headers: {
          Authorization: `Bearer ${await auth.getIdToken()}`
        }
      });
      if (response.status === 200) {
        const log_request = response.data;
        let request_messages = '';
        if (log_request.functions) {
          request_messages += '## Functions:\n' + log_request.functions + '\n';
        }
        if (log_request.max_tokens) {
          request_messages += '## Max Tokens on Answer:\n' + log_request.max_tokens + '\n';
        }
        if (log_request.temperature) {
          request_messages += '## Temperature:\n' + log_request.temperature + '\n';
        }
        if (log_request.top_p) {
          request_messages += '## Top P:\n' + log_request.top_p + '\n';
        }
        request_messages += '## Messages:\n';
        if (log_request.messages !== null){
          log_request.messages.forEach((m, i) => {
            m = log_request.messages[i];
            request_messages += '## ' + m.role + ':\n' + m.content + '\n\n';
          });
        }
        
        setRequestMessages(request_messages);
      }
    };
    fetchContext();
  }, [promptIdParam]);

  const crumbs = [
    { path: '/', breadcrumb: 'Home' },
    { path: '/logs', breadcrumb: 'Logs' },
    { path: window.location.href, breadcrumb: `${promptIdParam}` } // Current page
  ];

  return (
    <div className='grid bg-white p-8'>
      <Breadcrumbs crumbs={crumbs} />
      <div className='markdown-container min-h-[75vh]'>
        <h2 className='col-span-8 text-2xl font-bold'>Request:</h2>
        <div className='w-full p-4 border border-gray-200 rounded shadow'>
          <ReactMarkdown children={requestMessages} />
        </div>
        <h2 className='col-span-8 text-2xl font-bold'>Response:</h2>
        <div className='w-full p-4 border border-gray-200 rounded shadow'>
          <ReactMarkdown children={responseMessages} />
        </div>
      </div>

      <div className='flex justify-end mt-4 gap-1'>
      <Button color='primary' className='mt-auto' onClick={() => window.open(`/tests/${promptIdParam}/new?timestamp=${logTimestamp}`)}>
          Add test
        </Button>
        <Button color='primary' className='mt-auto' onClick={() => window.open(`/playground/${promptIdParam}?timestamp=${logTimestamp}`)}>
          Update prompt
        </Button>
      </div>

    </div>
  );
};

export default Log;
